module.exports = __webpack_public_path__ + "img/level_five.2be34625.png";